import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Home, AlertCircle, LockKeyhole, ServerCrash } from 'lucide-react';
import { useFirm, FirmMark } from '@/lib/brand';

function ErrorFrame({ icon: Icon, code, title, message, testId }) {
  const { firm } = useFirm();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid={testId}>
      <div className="max-w-lg w-full text-center">
        <div className="flex justify-center mb-6">
          <FirmMark firm={firm} size="lg" />
        </div>
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-slate-900 text-white mb-4">
          <Icon className="h-8 w-8" />
        </div>
        <div className="font-mono text-xs uppercase tracking-widest text-slate-500 mb-1">Error {code}</div>
        <h1 className="font-display text-3xl font-semibold text-slate-900 mb-2">{title}</h1>
        <p className="text-slate-600 mb-6">{message}</p>
        <div className="flex items-center justify-center gap-2">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-1.5" /> Volver
          </Button>
          <Link to="/"><Button><Home className="h-4 w-4 mr-1.5" /> Ir al inicio</Button></Link>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <ErrorFrame
      icon={AlertCircle}
      code="404"
      title="Página no encontrada"
      message="La página que busca no existe o fue movida a otra ubicación."
      testId="error-404"
    />
  );
}

export function ForbiddenPage() {
  return (
    <ErrorFrame
      icon={LockKeyhole}
      code="403"
      title="Acceso restringido"
      message="No tiene permiso para ver esta sección. Contacte al administrador si cree que esto es un error."
      testId="error-403"
    />
  );
}

export function ServerErrorPage() {
  return (
    <ErrorFrame
      icon={ServerCrash}
      code="500"
      title="Error del servidor"
      message="Ocurrió un problema inesperado. Ya lo estamos revisando — inténtelo nuevamente en unos minutos."
      testId="error-500"
    />
  );
}
